/**
 * Refusals because a capability is switched off, as the API client sees them.
 *
 * The paused-flags poll is up to a minute behind a switch being flipped; a
 * `503 FEATURE_DISABLED` is the first sign. The client reports it here and the
 * dashboard asks the poll again at once, so the page turns into its paused
 * screen instead of showing an error toast.
 *
 * A dependency-free leaf on purpose, like `maintenance.ts`: `api/client.ts`
 * imports it, so it must not import anything that imports the client back.
 */

const listeners = new Set<(flag: string | null) => void>();

export function reportFeatureDisabled(details: Record<string, unknown> | null): void {
  const flag = typeof details?.flag === 'string' ? details.flag : null;
  for (const listener of [...listeners]) listener(flag);
}

export function onFeatureDisabled(listener: (flag: string | null) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
